// Drawer.js
import React from 'react';
import RadioGroupRating from './ImageRating';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Typography, Button } from '@mui/material';

import { getUserImageRatings } from '../../../graphql/queries';
import { createUserImageRatings, updateUserImageRatings } from '../../../graphql/mutations';
import { API } from 'aws-amplify';

export default function ImageRatingDrawer({
  isCollapsed,
  setIsCollapsed,
  imageRatings,
  handleRatingChange,
  dialogImageUrl
}) {
  const imageUrl = dialogImageUrl.split('?')[0];
  const ratings = imageRatings[imageUrl] || {};

  console.log('imageRatings', imageRatings)
  const submitRatings = async () => {
    // First check if the record exists
    const existingRecord = await API.graphql({
      query: getUserImageRatings,
      variables: { s3_img_path: imageUrl },
    });

    console.log('existingRecord', existingRecord)

    const vals = {
      s3_img_path: imageUrl,
      user_id: ratings.user_id,
      rating_overall: ratings.OverallRating,
      rating_canopy: ratings.CanopyRating,
      rating_vine: ratings.VineRating,
      rating_fruit: ratings.FruitRating,
    };
  
    // If the record doesn't exist, create it. If it does exist, update it.
    if (!existingRecord.data.getUserImageRatings) {
      vals._version = null;
      console.log('vals', vals)
      console.log('here here')
      const result = await API.graphql({
        query: createUserImageRatings,
        variables: { input: vals },
      });
    } else {
      console.log('here2')
      vals._version = existingRecord.data.getUserImageRatings._version;
      const result = await API.graphql({
        query: updateUserImageRatings,
        variables: { input: vals },
      });
    }
  };

  return (
    <div>
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(480%)',
          background: 'white',
          borderRadius: '10%',
          padding: '4px',
          border: '0px 2px 2px 2px rgba(0, 0, 0, 0.1)',
          zIndex: 1,
        }}
      >
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            background: 'transparent',
            outline: 'none',
            border: 'none',
            width: '40px',
            height: '30px',
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'right',
            cursor: 'pointer',
          }}
        >
          {isCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </button>
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: isCollapsed ? '0' : '100%',
          transition: 'top 0.8s',
          background: 'white',
          width: '92.5%',
          height: '30%', // Adjust this based on how much of the Dialog you want the "Drawer" to cover
          display: 'flex',
          paddingTop: '8px',
          paddingRight: '10px',
          // boxShadow: '0px 0px 0px 2px rgba(0, 0, 0, 0.1)',
          // justifyContent: 'center',
          // alignItems: 'center',
          borderTop: '0px solid #e0e0e0',
        }}
      >
        <div style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
            <Typography>Overall Rating</Typography>

            <RadioGroupRating
              value={ratings.OverallRating}
              onValueChange={(newRating) => handleRatingChange(newRating, 'OverallRating')}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
            <Typography>Canopy Rating</Typography>
            <RadioGroupRating
              value={ratings.CanopyRating}
              onValueChange={(newRating) => handleRatingChange(newRating, 'CanopyRating')}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
            <Typography>Vine Rating</Typography>
            <RadioGroupRating
              value={ratings.VineRating}
              onValueChange={(newRating) => handleRatingChange(newRating, 'VineRating')}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
            <Typography>Fruit Rating</Typography>
            <RadioGroupRating
              value={ratings.FruitRating}
              onValueChange={(newRating) => handleRatingChange(newRating, 'FruitRating')}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', paddingTop: '5px' }}>
            <Button variant="contained" onClick={submitRatings}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
